import { Component, OnInit, ChangeDetectorRef, Input } from '@angular/core';
import { Collection } from '../../../common/generated-types';
import { NGXLogger } from 'ngx-logger';
import { ColorConfig, TitleInfo } from '../../../common/interfaces';
import { MOBILE_CARDS_PER_ROW } from '../../../common/constants';

@Component({
  selector: 'vsf-dual-collections-tiles',
  templateUrl: './dual-collections-tiles.component.html',
  styleUrls: ['./dual-collections-tiles.component.scss']
})
export class DualCollectionsTilesComponent implements OnInit {
  @Input() collectionsList: Collection[] = [];
  @Input() colorConfig: ColorConfig | null;
  @Input() title: string;
  @Input() subtitle: string;
  @Input() linePadding: string;
  @Input() titleInfo: TitleInfo | null = null;

  // Group collections into rows of two items each.
  groupedCollections: Collection[][] = [];
  itemsPerRow = MOBILE_CARDS_PER_ROW;

  constructor(private changeDetector: ChangeDetectorRef,
              private logger: NGXLogger) {}

  ngOnInit() {
    this.logger.info(`[DualCollectionsTiles] init ${JSON.stringify(this.collectionsList)}`);
    if (this.collectionsList && this.collectionsList.length > 0) {
      for (let i = 0; i < this.collectionsList.length; i += this.itemsPerRow) {
        this.groupedCollections.push(this.collectionsList.slice(i, i + this.itemsPerRow));
      }
    }
    this.changeDetector.markForCheck();
  }

  trackByGroup(index: number, group: Collection[]): string {
    return group[0]?.id || index.toString();
  }
}
